import { useRef } from 'react';
import { DEFAULT_PROFILE_IMAGE } from 'constants.js.erb';
import useScreenSize from 'hooks/useScreenSize';
import Chevron from 'icons/Chevron';
import TriangleLeft from 'icons/TriangleLeft';
import TriangleRight from 'icons/TriangleRight';
import { usePhotoGalleryContainer } from '..';
import styles from './styles/PhotoGalleryModalHeroImage.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Virtual } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/virtual';
import { Swiper as SwiperType } from 'swiper';
import Image from 'components/Image';
import MinuteMediaAd from '@/components/ads/MinuteMediaAd';

export default function PhotoGalleryModalHeroImage() {
  const [{ photoGallery, currentIndex, photoSlides, slideAdIndex }, { getPreviousImage, getNextImage, handleChangeIndex, isPhoto, isAd }] =
    usePhotoGalleryContainer();
  const { isSmallScreen } = useScreenSize();
  const swiperRef = useRef<SwiperType | null>(null);
  const currentSlide = photoSlides[currentIndex];

  return (
    <div className={styles.Slideshow}>
      {isSmallScreen ? (
        <>
          <Swiper
            modules={[Virtual]}
            virtual={{
              slides: photoSlides,
              addSlidesBefore: 1,
              addSlidesAfter: 1
            }}
            loop
            initialSlide={currentIndex}
            onSlideChange={swiper => handleChangeIndex(swiper.realIndex)}
            onSwiper={swiper => (swiperRef.current = swiper)}
          >
            {photoSlides.map((slide, index) => (
              <SwiperSlide key={index} virtualIndex={index}>
                <div className={styles.HeroImage}>
                  {isPhoto(slide) && <Image src={slide.s3Watermark ?? slide.watermark} alt={slide.filename} />}
                  {isAd(currentSlide) && (
                    <div className={styles.AdContainer}>
                      <MinuteMediaAd placement="IN_FEED" />
                    </div>
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <button className={styles.EllipseLeft} onClick={() => swiperRef.current?.slidePrev()}>
            <TriangleLeft />
          </button>
          <button className={styles.EllipseRight} onClick={() => swiperRef.current?.slideNext()}>
            <TriangleRight />
          </button>
        </>
      ) : (
        <>
          <button onClick={getPreviousImage} className={styles.PreviousImageButton}>
            <Chevron direction="left" />
          </button>
          <div className={styles.HeroImage}>
            {isPhoto(currentSlide) && (
              <div
                className={styles.Counter}
              >{`${currentIndex < slideAdIndex ? currentIndex + 1 : currentIndex} / ${photoGallery.photos.length}`}</div>
            )}
            {isPhoto(currentSlide) && <Image src={currentSlide.s3Watermark ?? currentSlide.watermark} alt={currentSlide.filename} />}
            {isAd(currentSlide) && (
              <div className={styles.AdContainer}>
                <MinuteMediaAd placement="IN_FEED" />
              </div>
            )}
          </div>
          <button onClick={getNextImage} className={styles.NextImageButton}>
            <Chevron direction="right" />
          </button>
        </>
      )}
      <div className={styles.HeroFooter}>
        <span>Credit: </span>
        <Image src={DEFAULT_PROFILE_IMAGE} alt="image of photographer" />
        <span className={styles.PhotographerText}>{`${photoGallery.photographer.firstName} ${photoGallery.photographer.lastName}`}</span>
      </div>
    </div>
  );
}
